import { Yup } from "../../yup-custom"

export const inputFileSchema = Yup.object({
  contentType: Yup.string().required(),
  originalFileName: Yup.string().required(),
  tempFileId: Yup.string().required(),
})
